export default __webpack_public_path__ + "static/hw_ff_binary_schem-5425c6e1ab7b9939c9c0a5d87612d107.png";